/* eslint-disable valid-typeof */
import { useQuery } from '@tanstack/react-query';
import useJwt from '../../utils/useJwt';

export type PlacesType = 'address' | 'city' | 'country' | 'postcode';
export interface PlacesFilter {
  type: 'address' | 'city' | 'country' | 'postcode';
  query: string;
}

export type PlacesResponse = {
  hits: {
    details: string;
    matchWords: string[];
    place_id: string;
    locale_names: string[];
  }[];
};

export default function usePlaces(filter: PlacesFilter, allowAllCountries = false) {
  const jwt = useJwt();
  let lang = 'FR';
  let country_code = 'FR';
  if (typeof window !== undefined) {
    lang = window.config?.LANGUAGE ?? 'FR';
    country_code = window.config?.LICENSE ?? 'FR';
  }

  const params = {
    ...filter,
    lang,
    jwt,
    country_code: !allowAllCountries ? country_code : null,
  };

  return useQuery<PlacesResponse, Error>(['places/verify', params], {
    enabled: (filter.query?.length ?? 0) > 0,
  });
}
